import { create } from 'zustand';
import type { Task, ValueUpdater } from './seedanceTypes';
import { resolveValueUpdater } from './seedanceStoreUtils';

/**
 * Seedance 任务公共状态。
 *
 * 创作页会创建本地 pending 任务并启动轮询，任务页会拉取/展示任务列表；
 * 任务统计（总数、已完成数）可供任务页等模块使用。
 *
 * 任务页分页页码、筛选条件等仍属于任务页局部 UI 状态，不放在这里。
 */
interface SeedanceTaskState {
  /** 本地任务和接口返回任务合并后的展示列表。 */
  tasks: Task[];
  /** 接口报告的账号任务总数（可能与单次 items 条数不一致）。 */
  taskTotal: number;
  /** 全局「已完成」数量；由列表聚合字段或分页统计得到，非当前页。 */
  taskSucceededTotal: number;
  /** 是否有未读的新完成任务（用于侧边栏红点提示）。 */
  hasUnreadSucceeded: boolean;
  setTasks: (tasks: ValueUpdater<Task[]>) => void;
  setTaskTotal: (taskTotal: number) => void;
  setTaskSucceededTotal: (n: number) => void;
  setHasUnreadSucceeded: (v: boolean) => void;
  /** @internal 跨模块启动轮询的句柄。 */
  ensurePolling: (taskId: string) => void;
  setEnsurePolling: (fn: (taskId: string) => void) => void;
}

export const useSeedanceTaskStore = create<SeedanceTaskState>((set) => ({
  tasks: [],
  taskTotal: 0,
  taskSucceededTotal: 0,
  hasUnreadSucceeded: false,
  setTasks: (tasks) =>
    set((state) => ({ tasks: resolveValueUpdater(state.tasks, tasks) })),
  setTaskTotal: (taskTotal) => set({ taskTotal }),
  setTaskSucceededTotal: (taskSucceededTotal) => set({ taskSucceededTotal }),
  setHasUnreadSucceeded: (hasUnreadSucceeded) => set({ hasUnreadSucceeded }),
  ensurePolling: () => {},
  setEnsurePolling: (ensurePolling) => set({ ensurePolling }),
}));
